import PropTypes from "prop-types";

/**
 * @memberof module:react/propTypes
 * @typedef {Object} Prime Style
 * @prop {string} id Prime style id
 * @prop {string} name Prime style name
 * @prop {number} displayIndex Display index
 */
export default PropTypes.shape({
  id: PropTypes.number,
  contextId: PropTypes.number,
  name: PropTypes.string,
  type: PropTypes.number,
  displayIndex: PropTypes.number
});



// WEBPACK FOOTER //
// ./app/propTypes/primeStyle.js